module.exports = __webpack_public_path__ + "static/img/son3.00b7f35a.jpg";